import {InvoiceAcceptStatus, InvoiceDocumentStatus, InvoiceStatus} from '@shared/types/invoice';

export const STATUS_COLOR_LIST = {
    GRAY: '#848484',
    GRAY_ALT: '#607C90',
    GREEN: '#4ABD74',
    GREEN_ALT: '#55CC52',
    RED: '#F54849',
    ORANGE: '#FF9500',
    BLUE: '#6466E9',
    YELLOW: '#C5A400',
    TEAL: '#2AD0BF',
};

const INVOICE_DOCUMENT_STATUS: Record<InvoiceDocumentStatus, string> = {
    BASIC: STATUS_COLOR_LIST['GREEN'],
    CORRECTIVE_BASIC: STATUS_COLOR_LIST['BLUE'],
    ANNULLING: STATUS_COLOR_LIST['GRAY'],
};

const INVOICE_STATUS: Record<InvoiceStatus, string> = {
    CREATED: STATUS_COLOR_LIST['BLUE'],
    APPROVED: STATUS_COLOR_LIST['GREEN_ALT'],
    VOID: STATUS_COLOR_LIST['GRAY_ALT'],
    DECLINED: STATUS_COLOR_LIST['RED'],
    NOT_ACTUAL: STATUS_COLOR_LIST['YELLOW'],
};

const INVOICE_ACCEPT_STATUS: Record<InvoiceAcceptStatus, string> = {
    NEW: STATUS_COLOR_LIST['BLUE'],
    ACCEPTED: STATUS_COLOR_LIST['GREEN'],
    REJECTED: STATUS_COLOR_LIST['ORANGE'],
    AUTO_ACCEPTED: STATUS_COLOR_LIST['TEAL'],
};

export const INVOICE_COLORS = {
    STATUS: INVOICE_STATUS,
    DOCUMENT: INVOICE_DOCUMENT_STATUS,
    ACCEPT: INVOICE_ACCEPT_STATUS,
};
